import { render, staticRenderFns } from "./SchoolArea.vue?vue&type=template&id=1103be52&scoped=true"
import script from "./SchoolArea.vue?vue&type=script&lang=js"
export * from "./SchoolArea.vue?vue&type=script&lang=js"
import style0 from "./SchoolArea.vue?vue&type=style&index=0&id=1103be52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1103be52",
  null
  
)

export default component.exports